module.exports = __webpack_public_path__ + "img/Japan.e6d48516.svg";